import http from './http'
import type { BlenderCatalog, Price } from '@/types/api'

export const catalogService = {
  async blender(): Promise<BlenderCatalog> {
    const { data } = await http.get<BlenderCatalog>('/catalog/blender')
    return data
  },

  async pricing(): Promise<Price[]> {
    const { data } = await http.get<Price[]>('/catalog/pricing')
    return data
  },
}
